<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">General Settings - New User</h5>
      <br />
    </div>
    <b-row>
      <b-col md="4">
        <b-card class="text-left">
          <b>Edit New User Setting</b>
          <b-row class="mt-4">
            <b-col md="5">
              <b-form-group id="fieldset-1" label="Start Date" label-for="input-1">
                <b-row class="m-0">
                  <b-col class="pr-0 pt-1 form-control img-calender-select border-right-0" md="3">
                    <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                  </b-col>
                  <b-col class="px-0">
                    <datepicker
                      input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 border-right-0"
                      placeholder="Select Date"
                      v-model="items.promo_start_date"
                      :format="customFormatter"
                      :disabledDates="disabledDates"
                    ></datepicker>
                  </b-col>
                  <b-col align="left" md="1" class="px-0">
                    <b-col
                      align="left"
                      class="pt-1 px-4 form-control del-calender-select border-left-0"
                      md="2"
                    >
                      <b-row align="left" class="pt-1">
                        <b-col>
                          <b-link @click="resetStardate" style="text-decoration:none">
                            <i class="text-danger fas fa-times"></i>
                          </b-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="New User Promo Limit"
                label-for="input-1"
              >
                <b-row>
                  <b-button size="sm" @click="min_day" pill>
                    <i class="fas fa-minus"></i>
                  </b-button>
                  <b-col md="2">
                    <b-form-input
                      v-model="items.promo_limit"
                      type="number"
                      v-validate="'required|numeric|min_value:1'"
                      name="promo_limit_day"
                      data-vv-as="New User Promo Limit"
                      readonly="readonly"
                      placeholder="-"
                    ></b-form-input>
                  </b-col>
                  <b-button size="sm" @click="plus_day" pill>
                    <i class="fas fa-plus"></i>
                  </b-button>
                  <b-col>
                    <label class="ml-3 mt-2">Day(s)</label>
                  </b-col>
                </b-row>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('promo_limit_day') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                class="required"
                label-class="control-label"
                label="New User Promo Requirement"
                label-for="input-1"
              >
                <b-row>
                  <b-button size="sm" @click="min_shipment" pill>
                    <i class="fas fa-minus"></i>
                  </b-button>
                  <b-col md="2">
                    <b-form-input
                      v-model="items.minimal_shipment_requirement"
                      type="number"
                      v-validate="'required|numeric|min_value:1'"
                      name="promo_requirement_shipment"
                      data-vv-as="New User Promo Requirement"
                      readonly="readonly"
                      placeholder="-"
                    ></b-form-input>
                  </b-col>
                  <b-button size="sm" @click="plus_shipment" pill>
                    <i class="fas fa-plus"></i>
                  </b-button>
                  <b-col>
                    <label class="ml-3 mt-2">Shipment(s)</label>
                  </b-col>
                </b-row>
                <p
                  class="text-danger"
                  style="width:100%;margin-top:.25rem;font-size: 80%;"
                >{{ veeErrors.first('promo_requirement_shipment') }}</p>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="New User Credit Amount"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <b-row>
                  <b-col md="1">
                    <label class="mt-1">Rp.</label>
                  </b-col>
                  <b-col>
                    <input
                      v-validate="'required|numeric'"
                      v-model="items.credit_amount"
                      name="credit_amount"
                      data-vv-as="New User Credit Amount"
                      id="input-1"
                      class="form-control"
                      placeholder="Enter Price"
                    />
                  </b-col>
                </b-row>

                <b-form-invalid-feedback
                  id="input-credit_amount-feedback"
                >{{ veeErrors.first('credit_amount') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group
                id="fieldset-1"
                label="Referral Amount"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <b-row>
                  <b-col md="1">
                    <label class="mt-1">Rp.</label>
                  </b-col>
                  <b-col>
                    <input
                      v-validate="'required|numeric'"
                      v-model="items.referral_amount"
                      name="referral_amount"
                      data-vv-as="Referral Amount"
                      class="form-control"
                      placeholder="Enter Price"
                    />
                  </b-col>
                </b-row>

                <b-form-invalid-feedback
                  id="input-referral_amount-feedback"
                >{{ veeErrors.first('referral_amount') }}</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <br />
          <b-row class="text-right">
            <b-col md="4" class="text-left">
              <label class="text-danger">
                *
                <b class="text-dark">Required</b>
              </label>
            </b-col>
            <b-col>
              <b-button variant="primary" :disabled="loading" @click="put()" class="mr-3" size="lg">
                Save
                <b-spinner v-if="loading" small label="Loading..."></b-spinner>
              </b-button>
              <router-link :to="{name: 'GeneralNewUserPromo'}">
                <b-button variant="outline-secondary" size="lg">Cancel</b-button>
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      loading: false,
      items: [],
      period_start: '',
      period_end: '',
      credit_amount: '',
      referral_amount: '',
      promo_limit_day: 1,
      promo_requirement_shipment: 1,
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
    };
  },
  beforeCreate() {
    this.$store
      .dispatch('GeneralSettingsModule/getNewUserId', this.$route.params.id)
      .then((response) => {
        this.loading = false;
      })
      .catch((error) => {
        this.$swal({
          type: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.GeneralSettingsModule.new_user_id,
      (newValue, oldValue) => {
        this.items = newValue;
      },
    );
  },
  methods: {
    min_day() {
      if (this.items.promo_limit == 1) {
        this.items.promo_limit == 1;
      } else {
        this.items.promo_limit -= 1;
      }
    },
    plus_day() {
      this.items.promo_limit++;
    },
    min_shipment() {
      if (this.items.minimal_shipment_requirement == 1) {
        this.items.minimal_shipment_requirement == 1;
      } else {
        this.items.minimal_shipment_requirement -= 1;
      }
    },
    plus_shipment() {
      this.items.minimal_shipment_requirement++;
    },
    put() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You will update this New User Settings!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      }).then((result) => {
        if (result.value) {
          this.$validator.validateAll().then((result) => {
            if (result) {
              this.loading = true;
              const formData = new FormData();
              formData.append('promo_limit', this.items.promo_limit);
              formData.append(
                'minimal_shipment_requirement',
                this.items.minimal_shipment_requirement,
              );
              formData.append('credit_amount', this.items.credit_amount);
              formData.append('referral_amount', this.items.referral_amount);

              if (this.items.promo_start_date != '') {
                const start = this.items.promo_start_date.toJSON().slice(0, 10);
                formData.append('promo_start_date', start);
              } else {
                formData.append(
                  'promo_start_date',
                  this.items.promo_start_date,
                );
              }

              this.$store
                .dispatch('GeneralSettingsModule/putNewUser', {
                  id: this.$route.params.id,
                  formData,
                })
                .then((response) => {
                  this.loading = false;
                  this.$router.push({ name: 'GeneralNewUserPromo' });
                  this.$swal({
                    type: 'success',
                    title: 'Your work has been saved',
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  console.log(response);
                })
                .catch((error) => {
                  this.loading = false;
                  this.$swal({
                    type: 'error',
                    title: 'Oops...',
                    text: error.response.data,
                    showConfirmButton: false,
                    timer: 1500,
                  });
                  this.serverError = error.response.data;
                  console.log(error);
                });
            } else {
              this.$swal('ERROR!', 'Your file cant be submit.', 'warning');
            }
          });
        }
      });
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    resetStardate() {
      this.items.promo_start_date = '';
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit('input', files[0]);
      }
    },
  },
};
</script>

<style>
</style>
